import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { UtilityService } from '@common/services';
import { LayoutSidenav } from '@modules/navigation/classes';
import { sideNavItems, sideNavSections } from '@modules/navigation/data/side-nav-invoice-management.data';
import { NavigationService } from '@modules/navigation/services';

@Component({
    selector: 'cwr-layout-invoice-management',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './layout-invoice-management.component.html',
    styleUrls: ['layout-invoice-management.component.scss'],
})
export class LayoutInvoiceManagementComponent  extends LayoutSidenav implements OnInit {
    sideNavItems = sideNavItems;
    sideNavSections = sideNavSections;

    constructor(
        public utilityService: UtilityService,
        public navigationService: NavigationService,
        public changeDetectorRef: ChangeDetectorRef
    ) {
        super(utilityService, navigationService, changeDetectorRef);
    }
    ngOnInit() {
        super.ngOnInit();
    }
}
